import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { type ParkingGateways } from 'src/features/parkingManagement/api/ParkingGatewayAPIs/useParkingGateways.ts';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import SquareIcon from 'src/registry/components/blocks/SquareIcon.tsx';
import { Button } from 'src/registry/ui/Button.tsx';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog.tsx';
import { generalMessages } from 'src/utils/messages.ts';

type DeleteParkingGatewayProps = {
    isDeleteParkingGatewayModalOpen: boolean;
    closeDeleteParkingGatewayModal: (isOpen: boolean) => void;
    deleteParkingGateway: ({ id }: { id: string }) => void;
    selectedParkingGateway: ParkingGateways;
};

const DeleteParkingGateway = ({
    isDeleteParkingGatewayModalOpen,
    closeDeleteParkingGatewayModal,
    deleteParkingGateway,
    selectedParkingGateway,
}: DeleteParkingGatewayProps) => {
    const { formatMessage } = useIntl();

    return (
        <Dialog open={isDeleteParkingGatewayModalOpen} onOpenChange={closeDeleteParkingGatewayModal}>
            <DialogContent>
                <DialogHeader>
                    <div className="flex gap-2">
                        <SquareIcon icon={faTrashAlt} />
                        <div>
                            <DialogTitle>{formatMessage(generalMessages.delete)}</DialogTitle>
                            <DialogDescription>
                                {formatMessage(parkingManagementMessages.deleteParkingGateway, {
                                    parkingGatewayName: selectedParkingGateway.name,
                                })}
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <p className="text-gray-500">
                        {formatMessage(parkingManagementMessages.deleteParkingGatewayConfirmation, {
                            parkingGatewayName: selectedParkingGateway.name,
                        })}
                    </p>
                </DialogBody>
                <DialogSeparator />
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="outline" type="button" className="flex-1">
                            {formatMessage(generalMessages.cancel)}
                        </Button>
                    </DialogClose>
                    <Button
                        variant="destructiveLight"
                        onClick={() => {
                            if (selectedParkingGateway) {
                                return (
                                    deleteParkingGateway({ id: selectedParkingGateway.id }),
                                    closeDeleteParkingGatewayModal(!isDeleteParkingGatewayModalOpen)
                                );
                            }
                        }}
                        className="flex-1"
                    >
                        {formatMessage(generalMessages.delete)}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteParkingGateway;
